import {useAuthUser, useSignOut} from 'react-auth-kit'
import {useIntl} from 'react-intl'
import {useLang} from 'src/app/modules/i18n/Metronici18n'

export default function useRequestParams() {
  const lang = useLang()
  const intl = useIntl()
  const auth = useAuthUser()
  const signOut = useSignOut()

  const errorMessage = intl.formatMessage({id: 'ERROR'})

  const product = {
    create_error: intl.formatMessage({id: 'CREATE.PRODUCT.ERROR'}),
    create_success: intl.formatMessage({id: 'CREATE.PRODUCT.SUCCESS'}),
    update_error: intl.formatMessage({id: 'UPDATE.PRODUCT.ERROR'}),
    update_success: intl.formatMessage({id: 'UPDATE.PRODUCT.SUCCESS'}),
  }

  const terminal = {
    create_error: intl.formatMessage({id: 'CREATE.TERMINAL.ERROR'}),
    create_success: intl.formatMessage({id: 'CREATE.TERMINAL.SUCCESS'}),
    update_error: intl.formatMessage({id: 'UPDATE.TERMINAL.ERROR'}),
    update_success: intl.formatMessage({id: 'UPDATE.TERMINAL.SUCCESS'}),
  }

  const vipTier = {
    create_error: intl.formatMessage({id: 'CREATE.VIP.ERROR'}),
    create_success: intl.formatMessage({id: 'CREATE.VIP.SUCCESS'}),
    update_error: intl.formatMessage({id: 'UPDATE.VIP.ERROR'}),
    update_success: intl.formatMessage({id: 'UPDATE.VIP.SUCCESS'}),
    delete_error: intl.formatMessage({id: 'DELETE.VIP.ERROR'}),
    delete_success: intl.formatMessage({id: 'DELETE.VIP.SUCCESS'}),
  }

  const vipProgram = {
    create_error: intl.formatMessage({id: 'CREATE.VIP.PROGRAM.ERROR'}),
    create_success: intl.formatMessage({id: 'CREATE.VIP.PROGRAM.SUCCESS'}),
    update_error: intl.formatMessage({id: 'UPDATE.VIP.PROGRAM.ERROR'}),
    update_success: intl.formatMessage({id: 'UPDATE.VIP.PROGRAM.SUCCESS'}),
    delete_error: intl.formatMessage({id: 'DELETE.VIP.PROGRAM.ERROR'}),
    delete_success: intl.formatMessage({id: 'DELETE.VIP.PROGRAM.SUCCESS'}),
  }

  const vipCampaignProduct = {
    create_error: intl.formatMessage({id: 'CREATE.VIP.CAMPAIGN.PRODUCT.ERROR'}),
    create_success: intl.formatMessage({id: 'CREATE.VIP.CAMPAIGN.PRODUCT.SUCCESS'}),
    update_error: intl.formatMessage({id: 'UPDATE.VIP.CAMPAIGN.PRODUCT.ERROR'}),
    update_success: intl.formatMessage({id: 'UPDATE.VIP.CAMPAIGN.PRODUCT.SUCCESS'}),
    delete_error: intl.formatMessage({id: 'DELETE.VIP.CAMPAIGN.PRODUCT.ERROR'}),
    delete_success: intl.formatMessage({id: 'DELETE.VIP.CAMPAIGN.PRODUCT.SUCCESS'}),
  }

  const referralProgram = {
    create_error: intl.formatMessage({id: 'CREATE.REFERRAL.PROGRAM.ERROR'}),
    create_success: intl.formatMessage({id: 'CREATE.REFERRAL.PROGRAM.SUCCESS'}),
    update_error: intl.formatMessage({id: 'UPDATE.REFERRAL.PROGRAM.ERROR'}),
    update_success: intl.formatMessage({id: 'UPDATE.REFERRAL.PROGRAM.SUCCESS'}),
    delete_error: intl.formatMessage({id: 'DELETE.REFERRAL.PROGRAM.ERROR'}),
    delete_success: intl.formatMessage({id: 'DELETE.REFERRAL.PROGRAM.SUCCESS'}),
  }

  const category = {
    create_error: intl.formatMessage({id: 'CREATE.CATEGORY.ERROR'}),
    create_success: intl.formatMessage({id: 'CREATE.CATEGORY.SUCCESS'}),
  }

  const store = {
    update_error: intl.formatMessage({id: 'UPDATE.STORE.ERROR'}),
    update_success: intl.formatMessage({id: 'UPDATE.STORE.SUCCESS'}),
  }

  const user = {
    create_error: intl.formatMessage({id: 'CREATE.USER.ERROR'}),
    create_success: intl.formatMessage({id: 'CREATE.USER.SUCCESS'}),
    update_error: intl.formatMessage({id: 'UPDATE.USER.ERROR'}),
    update_success: intl.formatMessage({id: 'UPDATE.USER.SUCCESS'}),
  }

  const file = {
    upload_error: intl.formatMessage({id: 'UPLOAD.ERROR'}),
    upload_success: intl.formatMessage({id: 'UPLOAD.SUCCESS'}),
    delete_error: intl.formatMessage({id: 'DELETE.ERROR'}),
    delete_success: intl.formatMessage({id: 'DELETE.SUCCESS'}),
  }

  const basket = {
    error: intl.formatMessage({id: 'UPDATE.BASKET.ERROR'}),
    success: intl.formatMessage({id: 'UPDATE.BASKET.SUCCESS'}),
  }

  const campaign = {
    create_error: intl.formatMessage({id: 'CREATE.CAMPAIGN.ERROR'}),
    create_success: intl.formatMessage({id: 'CREATE.CAMPAIGN.SUCCESS'}),
    update_error: intl.formatMessage({id: 'UPDATE.CAMPAIGN.ERROR'}),
    update_success: intl.formatMessage({id: 'UPDATE.CAMPAIGN.SUCCESS'}),
    delete_error: intl.formatMessage({id: 'DELETE.CAMPAIGN.ERROR'}),
    delete_success: intl.formatMessage({id: 'DELETE.CAMPAIGN.SUCCESS'}),
    status_error: intl.formatMessage({id: 'UPDATE.CAMPAIGN.STATUS.ERROR'}),
    status_success: intl.formatMessage({id: 'UPDATE.CAMPAIGN.STATUS.SUCCESS'}),
  }

  return {
    auth,
    signOut,
    errorMessage,
    errors: {
      campaign,
      product,
      terminal,
      category,
      store,
      user,
      file,
      basket,
      vipTier,
      vipProgram,
      vipCampaignProduct,
      referralProgram,
    },
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json-patch+json',
      Authorization: 'Bearer ' + auth()?.token,
      Language: lang,
    },
    headersWithoutAuth: {
      accept: 'application/json',
      'Content-Type': 'application/json-patch+json',
      Language: lang,
    },
  }
}
